import { useMutation, useQuery } from "@tanstack/react-query";
import Box from "@mui/material/Box";
import { Translate, useTranslation } from "@privacy/translations";
import { archiveInformationTypeMutationOptions, informationTypeByIdQueryOptions } from "../../api/informationTypes";
import { ConfirmDeleteDialog } from "../../shared/ConfirmDeleteDialog";

export const InformationTypeArchiveConfirmDialog = ({
  informationTypeId,
  informationTypeName,
  onClose,
}: {
  informationTypeId: string;
  informationTypeName: string;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const archiveMutation = useMutation(archiveInformationTypeMutationOptions(informationTypeId));
  const detailQuery = useQuery(informationTypeByIdQueryOptions(informationTypeId));

  const totalConnections = detailQuery.data
    ? detailQuery.data.connectedSystemsInfo.storedConnections.length +
      detailQuery.data.connectedSystemsInfo.usedConnections.length
    : 0;

  return (
    <ConfirmDeleteDialog
      isOpen
      onClose={onClose}
      onDelete={() => archiveMutation.mutateAsync()}
      headerText={t("InformationType.Archive.Confirm.Title")}
      message={
        <>
          <Translate
            translationKey="InformationType.Archive.Confirm.Message"
            values={{
              name: (
                <Box component="span" sx={{ fontWeight: "bold" }}>
                  {informationTypeName}
                </Box>
              ),
            }}
          />
          {totalConnections > 0 && (
            <>
              {" "}
              <Translate
                translationKey={
                  totalConnections === 1
                    ? "InformationType.Archive.Confirm.ConnectionLine.Singular"
                    : "InformationType.Archive.Confirm.ConnectionLine.Plural"
                }
                values={{ count: totalConnections }}
              />
            </>
          )}
        </>
      }
      confirmButtonLabel={t("InformationType.Archive.Confirm.Button")}
      id="confirm-archive-information-type"
      onKeyDown={e => e.key === "Tab" && e.stopPropagation()}
    />
  );
};
